(function() {
    let lastFixableId = 0;
    const scrollTopOffsets = {};

    window.c24LpInitializeFixables = function(parent) {
        if (!parent) {
            parent = 'body';
        }

        $('.js24Fixable .js24FixableTrigger', parent).each(function(_, fadeInTriggerElement) {
            const fadeInTrigger = $(fadeInTriggerElement);

            // vue fixables are initialized by the vue component in the "mounted" function
            if (parent === 'body' && fadeInTrigger.closest('.vue').length) {
                return;
            }

            const fixable = fadeInTrigger.closest('.js24Fixable');

            const fadeOutTriggerSelector = fixable.data('fade-out-trigger-selector');
            const fadeOutTrigger = fadeOutTriggerSelector ? document.querySelector(fadeOutTriggerSelector) : null;

            const isFixed = fixable.hasClass('js24Fixed');

            const status = {
                id: lastFixableId++,
                isFixed: isFixed,
                fadeInTriggerOffset: fadeInTrigger.offset().top + fadeInTrigger.outerHeight(true),
            };

            visiblityHandler(fixable, fadeInTrigger, fadeOutTrigger, status, true);

            document.addEventListener('scroll', function() {

                if (!status.isFixed && !fixable.hasClass('js24Fixed')) {
                    status.fadeInTriggerOffset = fadeInTrigger.offset().top + fadeInTrigger.outerHeight(true);
                }

                visiblityHandler(fixable, fadeInTrigger, fadeOutTrigger, status, false);
            }, {
                passive: true,
            });
        });

        function visiblityHandler(fixable, fadeInTrigger, fadeOutTrigger, status, noFadeIn) {
            const fadeInTriggered = isFadeInTriggered(fadeInTrigger, status);

            if (status.isFixed) {
                if (!fadeInTriggered || isFadeOutTriggered(fadeOutTrigger)) {
                    unfix(fixable, status);
                }
            } else {
                if (fadeInTriggered && !isFadeOutTriggered(fadeOutTrigger)) {
                    fix(fixable, status, noFadeIn);
                }
            }
        }

        function isFadeInTriggered(fadeInTrigger, status) {
            if (!fadeInTrigger.is(':visible')) {
                return false;
            }

            return $(window).scrollTop() > status.fadeInTriggerOffset;
        }

        function isFadeOutTriggered(fadeOutTrigger) {
            if (!fadeOutTrigger) {
                return false;
            }

            if (!fadeOutTrigger.is(':visible')) {
                return false;
            }

            const pos = fadeOutTrigger.getBoundingClientRect();
            if (pos.top < window.innerHeight && pos.bottom >= 0) {
                return true;
            }

            return false;
        }

        function fix(fixable, status, noFadeIn) {
            status.isFixed = true;

            if (fixable.hasClass('js24Fixed')) {
                return;
            }

            // add a clone to reserve the space of the original element
            fixable.clone().addClass('js24FixableClone').appendTo(fixable.parent());

            if (noFadeIn) {
                fixable.addClass('js24Fixed').show().stop();
                onFixedIsVisible(fixable, status);
            } else {
                fixable.addClass('js24Fixed').hide().stop().fadeIn({
                    duration: 500,
                    easing: 'swing',
                    complete: function () {
                        onFixedIsVisible(fixable, status);
                    },
                });
            }
        }

        function onFixedIsVisible(fixable, status) {
            const viewportTop = $(window).scrollTop();
            const fixableTop = fixable.offset().top;
            const topOffset = fixableTop - viewportTop;
            const isNearTop = topOffset < 100;

            if (isNearTop) {
                const fixedHeight = topOffset + fixable.outerHeight(true);
                updateScrollTopOffset(status.id, fixedHeight);
            } else {
                updateScrollTopOffset(status.id, 0);
            }

            ensureNotOverlappingUrlElement(fixable);
        }

        function unfix(fixable, status) {
            status.isFixed = false;

            if (!fixable.hasClass('js24Fixed')) {
                return;
            }

            $('.js24FixableClone', fixable.parent()).remove();
            fixable.removeClass('js24Fixed');

            updateScrollTopOffset(status.id, 0);
        }

        function updateScrollTopOffset(id, fixedHeight) {
            scrollTopOffsets[id] = fixedHeight;
            updateTotalScrollTopOffset();
        }

        function updateTotalScrollTopOffset() {
            const maxScrollTopOffset = Math.max(...Object.values(scrollTopOffsets));

            window.c24FixableScrollTopOffset = maxScrollTopOffset > 0 ? maxScrollTopOffset + 20 : 0;
            $('html').css('scroll-padding-top', maxScrollTopOffset > 0 ? maxScrollTopOffset + 30 : 30);
        }

        function ensureNotOverlappingUrlElement(fixable) {
            const urlId = window.location.hash.replace('#', '');
            const urlElement = urlId ? $(`#${urlId}`) : null;
            if (!urlElement || !urlElement.length) {
                return;
            }

            const fixableTop = fixable.offset().top;
            const fixableHeight = fixable.outerHeight(true);
            const fixableBottom = fixableTop + fixableHeight;

            const urlElementTop = urlElement.offset().top;

            // if the url element is inside the fixable, scroll to not overlap it
            if (urlElementTop >= fixableTop && urlElementTop <= fixableBottom) {
                $(window).scrollTop(urlElementTop - fixableHeight - 30);

                console.log('fixable| scroll to not overlap', {
                    fixableHeight,
                    fixableTop,
                    fixableBottom,
                    urlElementTop,
                    scrollTop: urlElementTop - fixableHeight - 30,
                });
            }
        }
    };
})();
